import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Modal from "react-bootstrap/Modal";
import {
  changeRefreshYear,
  getDefaultRefreshRange,
  getRefreshMonthOptions,
  getYearOptions,
  validateRefreshRange,
} from "./pnlReportUtils";

const MonthSelect = ({ id, label, value, options, disabled, onChange }) => (
  <div className="pnl-field">
    <label htmlFor={id}>{label}</label>
    <select id={id} value={value} disabled={disabled} onChange={(event) => onChange(Number(event.target.value))}>
      {options.map((month) => (
        <option key={month.value} value={month.value} disabled={month.disabled}>{month.label}</option>
      ))}
    </select>
  </div>
);

MonthSelect.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  options: PropTypes.array.isRequired,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};

const PnLRefreshModal = ({ show, refreshing, onCancel, onConfirm }) => {
  const [range, setRange] = useState(() => getDefaultRefreshRange());

  useEffect(() => {
    if (show) setRange(getDefaultRefreshRange());
  }, [show]);

  const monthOptions = getRefreshMonthOptions(range.year);
  const error = validateRefreshRange(range);

  return (
    <Modal show={show} onHide={onCancel} centered backdrop="static">
      <Modal.Header closeButton={!refreshing}>
        <Modal.Title as="h2" className="h5">Refresh report</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Saved figures for every category in the selected months are deleted, recalculated from the current data and
          saved again.
        </p>
        <div className="pnl-refresh-range">
          <div className="pnl-field">
            <label htmlFor="pnl-refresh-year">Year</label>
            <select
              id="pnl-refresh-year"
              value={range.year}
              disabled={refreshing}
              onChange={(event) => setRange(changeRefreshYear(event.target.value))}
            >
              {getYearOptions().map((year) => (
                <option key={year} value={year}>{year}</option>
              ))}
            </select>
          </div>
          <MonthSelect
            id="pnl-refresh-from"
            label="From month"
            value={range.fromMonth}
            options={monthOptions}
            disabled={refreshing}
            onChange={(fromMonth) => setRange((previous) => ({ ...previous, fromMonth }))}
          />
          <MonthSelect
            id="pnl-refresh-to"
            label="To month"
            value={range.toMonth}
            options={monthOptions}
            disabled={refreshing}
            onChange={(toMonth) => setRange((previous) => ({ ...previous, toMonth }))}
          />
        </div>
        {error && <div className="pnl-filter-error" role="alert">{error}</div>}
        <p className="pnl-refresh-note">
          The current month is calculated live and cannot be refreshed. Shipping labels awaiting returns stay
          provisional until their returns are closed from the row details.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn cus-primary-transparent-btn" onClick={onCancel} disabled={refreshing}>
          Cancel
        </button>
        <button
          type="button"
          className="btn cus-seconday-bg-btn"
          onClick={() => onConfirm(range)}
          disabled={refreshing || Boolean(error)}
        >
          {refreshing ? "Refreshing..." : "Refresh now"}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

PnLRefreshModal.propTypes = {
  show: PropTypes.bool.isRequired,
  refreshing: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default PnLRefreshModal;
